
import { computed, defineComponent, nextTick, onMounted } from 'vue';
import KTUserMenu from '@/layout/header/partials/UserMenu.vue';
import { useStore } from 'vuex';
import type { User } from '@/store/modules/AuthModule';
import { MenuComponent } from '@/assets/ts/components';
import { resolveAvatarUrl } from '@/core/helpers/avatar';

export default defineComponent({
  name: 'topbar',
  components: {
    KTUserMenu,
  },
  setup() {
    const store = useStore();
    const userDetail = computed<User>(() => store.getters.currentUser || ({} as User));

    const displayName = computed(() => userDetail.value.fullName || 'Người dùng');

    const avatarSrc = computed(() => resolveAvatarUrl(userDetail.value.avatar));

    const workingYear = computed(() => store.getters.getSelectedYear || '');

    onMounted(() => {
      nextTick(() => {
        MenuComponent.reinitialization();
      });
    });

    return {
      userDetail,
      displayName,
      avatarSrc,
      workingYear,
    };
  },
});
